module.exports = __webpack_public_path__ + "img/door.035c5491.svg";